import styled, { keyframes } from "styled-components";
import React, { useEffect, useCallback, useState, useRef } from "react";
import Spark from "assets/images/UI/ion_sparkles-outline.svg";
import { Icon, Dimmer } from "semantic-ui-react";

const ReportType = (props) => {
  const { templates, next, setTemplate, goBack } = props;
  return (
    <Container>
      <BackButton onClick={() => goBack()}>
        <Icon name="chevron left" style={{ marginTop: -7 }} />
        Back
      </BackButton>
      <T1>Story Templates</T1>
      <T2>
        Explore our range of solutions to address specific areas of improvement
        in your organization's culture.
      </T2>
      <Options>
        {templates?.map((template, index) => {
          return (
            <OptionItem
              key={index}
              onClick={() => {
                setTemplate(template?.id);
                next();
              }}
              selectTemplate={() => setTemplate(template?.id)}
              title={template.name}
            />
          );
        })}
      </Options>
    </Container>
  );
};

const OptionItem = ({
  title,
  description,
  onClick,
  coming_soon,
  openModal,
  selectTemplate,
}) => {
  return (
    <Card>
      <Dimmer active={coming_soon}>Coming Soon</Dimmer>
      <Title>
        <Icon2 src={Spark} />
        {/* TODO: Update name */}
        Category Story
      </Title>
      {/* <Description>{description}</Description> */}
      {!coming_soon && (
        <ArrowContainer onClick={() => onClick()}>
          <Icon name={"arrow right"} />
        </ArrowContainer>
      )}
    </Card>
  );
};

const Container = styled.div`
  padding-left: 20px;
  font-family: "raleway";
`;

const T1 = styled.div`
  font-size: 24px;
  font-weight: bold;
  margin-bottom: 10px;
`;

const T2 = styled.div`
  font-size: 16px;
  margin-bottom: 30px;
`;

const Title = styled.div`
  font-size: 16px;
  font-weight: bold;
  margin-bottom: 20px;
`;

const Options = styled.div`
  display: flex;
  flex-wrap: wrap;
  margin-top: 20px;
`;

const BackButton = styled.div`
  font-size: 14px;
  color: #b3b3b3;
  cursor: pointer;
  display: flex;
  align-items: center;
  font-size: 12px;
  margin-bottom: 20px;
`;

const More = styled.div`
  font-size: 12px;
  color: #007bff;
  cursor: pointer;
  position: absolute;
  bottom: 10px;
  left: 20px;
`;

const Card = styled.div`
  width: 300px;
  height: 200px;
  border: 1px solid #ccc;
  border-radius: 10px;
  margin-right: 10px;
  padding: 20px;
  margin-bottom: 10px;
  position: relative;
`;

const Description = styled.div`
  line-height: 1.5;
`;

const Icon2 = styled.img`
  width: 20px;
  margin-right: 10px;
`;

const ArrowContainer = styled.div`
  position: absolute;
  right: 10px;
  bottom: 10px;
  cursor: pointer;
  color: #007bff;
  font-size: 20px;
`;

const ButtonContainer = styled.div`
  display: flex;
  margin-top: 20px;
  justify-content: flex-end;
  align-items: center;
`;

const Button = styled.div`
  color: #2d70e2;
  border: 1px solid #2d70e2;
  font-size: 14px;
  padding: 5px 10px;
  font-weight: 600;
  cursor: pointer;
  font-family: "Raleway";
`;

export default ReportType;
